import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid } from '@material-ui/core';
import {
    FHEContainerForm,
    FHEReactSelect,
    FHETextField,
    FHECheckbox,
    FHEItemText,
    FHEWeatherAutoComplete,
    FormEditButton,
    FormSaveButton
} from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import memoizeOne from 'memoize-one';
import getSelectors from '../selectors';

class FormHome extends PureComponent {
    static propTypes = {
        sendDataFunc: PropTypes.func.isRequired,
        home: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
        managements: PropTypes.object.isRequired,
        managementsArray: PropTypes.array.isRequired,
        searchCityUrl: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired,
        homeId: PropTypes.string,
        stepHomeForm: PropTypes.object
    };

    static defaultProps = {
        stepHomeForm: null,
        homeId: null
    };

    constructor(props) {
        super(props);
        const { type } = props;
        this.state = {
            formDisabled: type === 'update',
            homeForm: this.getDataForm(),
            textInput_error: {},
            sendLoading: false
        };
        this.orientations = [
            { value: 'SE', label: Translator.translate('general.orientation.SE') },
            { value: 'SSE', label: Translator.translate('general.orientation.SSE') },
            { value: 'S', label: Translator.translate('general.orientation.S') },
            { value: 'SSO', label: Translator.translate('general.orientation.SSO') },
            { value: 'SO', label: Translator.translate('general.orientation.SO') },
            { value: 'OSO', label: Translator.translate('general.orientation.OSO') },
            { value: 'O', label: Translator.translate('general.orientation.O') },
            { value: 'ONO', label: Translator.translate('general.orientation.ONO') },
            { value: 'NO', label: Translator.translate('general.orientation.NO') },
            { value: 'NNO', label: Translator.translate('general.orientation.NNO') },
            { value: 'N', label: Translator.translate('general.orientation.N') },
            { value: 'NNE', label: Translator.translate('general.orientation.NNE') },
            { value: 'NE', label: Translator.translate('general.orientation.NE') },
            { value: 'ENE', label: Translator.translate('general.orientation.ENE') },
            { value: 'E', label: Translator.translate('general.orientation.E') },
            { value: 'ESE', label: Translator.translate('general.orientation.ESE') }
        ];
        this.densities = [
            { value: 'montain', label: Translator.translate('general.density.montain') },
            { value: 'rural', label: Translator.translate('general.density.rural') },
            { value: 'urban', label: Translator.translate('general.density.urban') },
            { value: 'industrial', label: Translator.translate('general.density.industrial') }
        ];
        this.moduleTypes = [
            { value: 'low-ventilated', label: Translator.translate('general.moduleType.low-ventilated') },
            { value: 'ventilated', label: Translator.translate('general.moduleType.ventilated') },
            { value: 'well-ventilated', label: Translator.translate('general.moduleType.well-ventilated') }
        ];
        this.meters = [
            { value: 3000, label: '3' },
            { value: 6000, label: '6' },
            { value: 9000, label: '9' },
            { value: 12000, label: '12' },
            { value: 15000, label: '15' },
            { value: 18000, label: '18' }
        ];
        this.pitches = [
            { value: 0, label: '0' },
            { value: 5, label: '5' },
            { value: 10, label: '10' },
            { value: 15, label: '15' },
            { value: 20, label: '20' },
            { value: 25, label: '25' },
            { value: 30, label: '30' },
            { value: 35, label: '35' },
            { value: 40, label: '40' },
            { value: 45, label: '45' },
            { value: 50, label: '50' },
            { value: 55, label: '55' },
            { value: 60, label: '60' },
            { value: 65, label: '65' },
            { value: 70, label: '70' },
            { value: 75, label: '75' },
            { value: 80, label: '80' },
            { value: 85, label: '85' },
            { value: 90, label: '90' }
        ];
    }

    getDataForm = () => {
        const { type, home, managements, stepHomeForm } = this.props;

        const management = managements.getIn([home.getIn(['managementId'], '').toString()], new Map());
        const buildingType = management.getIn(['buildingType'], null);
        return {
            label: stepHomeForm ? stepHomeForm.label : type === 'update' ? home.get('label') : null,
            address: type === 'update' ? (buildingType === 'apartments' ? management.get('address') : home.get('address')) : null,
            city: type === 'update' ? (buildingType === 'apartments' ? management.get('city') : home.get('city')) : null,
            postalCode: type === 'update' ? (buildingType === 'apartments' ? management.get('postalCode') : home.get('postalCode')) : null,
            weatherCity: type === 'update' ? (buildingType === 'apartments' ? management.get('weatherCity') : home.get('weatherCity')) : null,
            apNum: type === 'update' ? (buildingType === 'apartments' ? home.get('apNum') : home.get('apNum')) : null,
            isThreephase: type === 'update' ? home.get('isThreephase') : false,
            homeState: type === 'update' ? home.get('homeState') : null,
            managementId: type === 'update' ? parseInt(home.get('managementId')) : null,
            rentAgency: type === 'update' ? home.get('rentAgency') : null,
            buildingType: type === 'update' ? (management === undefined ? null : buildingType) : null,
            constructionDensity: type === 'update' ? home.get('constructionDensity') : null,
            boxMac: stepHomeForm ? stepHomeForm.boxMac : null,
            meter: type === 'update' ? home.get('meter') : null,
            kWhPrice: type === 'update' ? home.get('kWhPrice') : null,
            altitude: type === 'update' ? home.get('altitude') : null,
            latitude: type === 'update' ? home.get('latitude') : null,
            longitude: type === 'update' ? home.get('longitude') : null
        };
    };

    loadInputs = () => {
        const { type } = this.props;

        this.setState({
            formDisabled: type === 'update',
            homeForm: this.getDataForm()
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    formatForm = () => {
        const { homeForm } = this.state;

        let form = { ...homeForm };
        Object.keys(form).forEach(key => {
            if (form[key] === '') {
                form[key] = null;
            }
        });

        if (homeForm.buildingType === 'apartments') {
            delete form.city;
            delete form.address;
            delete form.weatherCity;
            delete form.postalCode;
        } else {
            delete form.apNum;
        }
        return form;
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    saveHome = () => {
        const { homeForm } = this.state;
        const { sendDataFunc, history } = this.props;

        const formattedForm = this.formatForm();

        if (this.validateForm(formattedForm)) {
            this.setState({
                formDisabled: true,
                sendLoading: true
            });
            return sendDataFunc(formattedForm).catch(error => {
                Toastr.error(Translator.translate(`generic.home.actions.addHomeError`, homeForm.label));
                this.setState({
                    formDisabled: false,
                    sendLoading: false
                });
                if (error.validation && error.validation.errors) {
                    return this.handleFormError(error.validation.errors, Translator.translate(`generic.home.actions.addHomeError`, homeForm.label));
                }
            });
        }
    };

    confirmEdit = () => {
        const { homeForm } = this.state;
        const { sendDataFunc, homeId, history } = this.props;

        const formattedForm = this.formatForm();

        if (this.validateForm(formattedForm)) {
            this.setState({
                sendLoading: true
            });
            return sendDataFunc(homeId, formattedForm)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.home.actions.editHomeSuccess`, homeForm.label));
                    this.loadInputs();
                    this.setState({
                        formDisabled: true,
                        sendLoading: false
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false
                    });
                    Toastr.error(
                        Translator.translateWithFallback(`api.message.${error.message}`, `generic.home.actions.editHomeError`, homeForm.label)
                    );
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate(`generic.home.actions.editHomeError`, homeForm.label)
                        );
                    }
                });
        }
    };

    handleEdit = () => {
        const { formDisabled } = this.state;

        if (!formDisabled) this.loadInputs();
        this.setState({
            formDisabled: !formDisabled,
            textInput_error: {}
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    handleFormData = (field, value) => {
        const { homeForm } = this.state;
        if (field === 'boxMac') value = value.replace(/:/g, '');
        this.setState({
            homeForm: { ...homeForm, [field]: value }
        });
    };

    handleChange = event => {
        const { homeForm, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        const fieldLengthRules = {
            label: 80,
            address: 500,
            city: 255,
            postalCode: 5,
            apNum: 10,
            rentAgency: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = homeForm[event.target.name];
        if (targetValue === '') targetValue = null;

        this.setState({
            homeForm: { ...homeForm, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    validateForm(form) {
        const { homeForm } = this.state;
        const { managements } = this.props;
        const management = managements.get(form.managementId ? form.managementId.toString() : null);
        const errors = {};
        const error = Translator.translate('general.fields.error.any.empty');
        if (homeForm.buildingType === 'apartments') {
            if (this.isEmpty(form.apNum)) errors['apNum'] = error;
        }
        if (homeForm.buildingType === 'district') {
            if (this.isEmpty(form.address)) errors['address'] = error;

            if (this.isEmpty(form.city)) errors['city'] = error;

            if (this.isEmpty(form.postalCode)) errors['postalCode'] = error;

            if (this.isEmpty(form.weatherCity)) errors['weatherCity'] = error;
        }
        if (this.isEmpty(form.constructionDensity)) errors['constructionDensity'] = error;
        if (this.isEmpty(form.label)) errors['label'] = error;
        if (this.isEmpty(form.meter)) errors['meter'] = error;
        if (this.isEmpty(form.kWhPrice)) errors['kWhPrice'] = error;

        if (this.isEmpty(form.managementId) || management === undefined) errors['managementId'] = error;
        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    }

    renderButtonsForm() {
        const { formDisabled, sendLoading } = this.state;
        const { profile, type, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        if (type === 'update') {
            if (profile.get('admin') || userRights.includes('homeDetailsUpdate'))
                return (
                    <FormEditButton
                        formDisabled={formDisabled}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                    />
                );
        } else return <FormSaveButton sendFunc={this.saveHome} sendLoading={sendLoading} />;
    }

    getSelectedMeter = memoizeOne(meter => {
        return this.meters.find(x => x.value === meter);
    });

    getSelectedDensity = memoizeOne(density => {
        return this.densities.find(x => x.value === density);
    });

    getSelectedManagement = memoizeOne(managementId => {
        const { managementsArray } = this.props;
        return managementsArray.find(x => x.value === managementId);
    });

    handleReactSelect = (event, options) => {
        const { homeForm, textInput_error } = this.state;
        const { managements, home } = this.props;

        const newTextInput_error = tools.removeKey(textInput_error, options.name);

        if (options.name === 'managementId') {
            const management = managements.get(event.value.toString());
            const buildingType = management.get('buildingType');
            this.setState({
                homeForm: {
                    ...homeForm,
                    managementId: event.value,
                    address: buildingType === 'apartments' ? management.get('address') : home.getIn(['address'], null),
                    city: buildingType === 'apartments' ? management.get('city') : home.getIn(['city'], null),
                    postalCode: buildingType === 'apartments' ? management.get('postalCode') : home.getIn(['postalCode'], null),
                    weatherCity: buildingType === 'apartments' ? management.get('weatherCity') : home.getIn(['weatherCity'], null),

                    buildingType
                },
                textInput_error: newTextInput_error
            });
        } else {
            this.setState({
                homeForm: { ...homeForm, [options.name]: event.value },
                textInput_error: newTextInput_error
            });
        }
    };
    render() {
        const { textInput_error, formDisabled, homeForm } = this.state;
        const { type, searchCityUrl, managementsArray, classes } = this.props;
        return (
            <Fragment>
                {this.renderButtonsForm()}

                <FHEContainerForm>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="label"
                                value={!homeForm.label || homeForm.label === null ? '' : homeForm.label}
                                error={textInput_error.label}
                                label={Translator.translate('general.table.column.label')}
                                name="label"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="meter"
                                label={Translator.translate('general.table.column.meter')}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedMeter(homeForm.meter)}
                                choices={this.meters}
                                disabled={formDisabled}
                                error={textInput_error.meter}
                                suffix="kVa"
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="kWhPrice"
                                type="number"
                                value={!homeForm.kWhPrice || homeForm.kWhPrice === null ? '0.17' : homeForm.kWhPrice}
                                error={textInput_error.kWhPrice}
                                label={Translator.translate('general.table.column.kWhPrice')}
                                name="kWhPrice"
                                onChange={this.handleChange}
                                suffix="€"
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="constructionDensity"
                                label={Translator.translate('general.table.column.constructionDensity')}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedDensity(homeForm.constructionDensity)}
                                choices={this.densities}
                                error={textInput_error.constructionDensity}
                                disabled={formDisabled}
                            />
                        </Grid>
                        {type === 'update' && (
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.homeState')}
                                    itemContent={
                                        !homeForm.homeState || homeForm.homeState === null
                                            ? ''
                                            : Translator.translate(`general.home-${homeForm.homeState}`)
                                    }
                                    classContent={homeForm.homeState === 'active' ? classes.activedColor : classes.disactivedColor}
                                />
                            </Grid>
                        )}
                        <Grid container item sm={12} md={6} lg={type === 'update' ? 4 : 8}>
                            <FHECheckbox
                                checked={!!homeForm.isThreephase}
                                label={Translator.translate('general.table.column.isThreephase')}
                                value="isThreephase"
                                disabled={formDisabled}
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="managementId"
                                label={Translator.translate('general.table.column.residence')}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedManagement(homeForm.managementId)}
                                choices={managementsArray}
                                error={textInput_error.managementId}
                                disabled={formDisabled}
                            />
                        </Grid>

                        {homeForm.buildingType === 'apartments' ? (
                            <Fragment>
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHETextField
                                        disabled={formDisabled}
                                        id="apNum"
                                        value={!homeForm.apNum || homeForm.apNum === null ? '' : homeForm.apNum}
                                        error={textInput_error.apNum}
                                        label={Translator.translate('general.table.column.apartmentNumber')}
                                        name="apNum"
                                        onChange={this.handleChange}
                                    />
                                </Grid>
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHEItemText
                                        itemTitle={Translator.translate('general.table.column.address')}
                                        itemContent={!homeForm.address || homeForm.address === null ? '' : homeForm.address}
                                    />
                                </Grid>
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHEItemText
                                        itemTitle={Translator.translate('general.table.column.city')}
                                        itemContent={!homeForm.city || homeForm.city === null ? '' : homeForm.city}
                                    />
                                </Grid>
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHEItemText
                                        itemTitle={Translator.translate('general.table.column.postalCode')}
                                        itemContent={!homeForm.postalCode || homeForm.postalCode === null ? '' : homeForm.postalCode}
                                    />
                                </Grid>
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHEItemText
                                        itemTitle={Translator.translate('general.table.column.weatherCity')}
                                        itemContent={homeForm.weatherCity === null ? '' : homeForm.weatherCity}
                                    />
                                </Grid>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHETextField
                                        disabled={formDisabled}
                                        id="address"
                                        value={!homeForm.address || homeForm.address === null ? '' : homeForm.address}
                                        error={textInput_error.address}
                                        label={Translator.translate('general.table.column.address')}
                                        name="address"
                                        onChange={this.handleChange}
                                    />
                                </Grid>
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHETextField
                                        disabled={formDisabled}
                                        id="city"
                                        value={!homeForm.city || homeForm.city === null ? '' : homeForm.city}
                                        error={textInput_error.city}
                                        label={Translator.translate('general.table.column.city')}
                                        name="city"
                                        onChange={this.handleChange}
                                    />
                                </Grid>
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHETextField
                                        disabled={formDisabled}
                                        id="postalCode"
                                        value={!homeForm.postalCode || homeForm.postalCode === null ? '' : homeForm.postalCode}
                                        error={textInput_error.postalCode}
                                        label={Translator.translate('general.table.column.postalCode')}
                                        name="postalCode"
                                        onChange={this.handleChange}
                                    />
                                </Grid>
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHEWeatherAutoComplete
                                        disabled={formDisabled}
                                        id="weatherCity"
                                        baseValue={homeForm.weatherCity === null ? '' : homeForm.weatherCity}
                                        error={textInput_error.weatherCity}
                                        label={Translator.translate('general.table.column.weatherCity')}
                                        name="weatherCity"
                                        query={searchCityUrl}
                                        selectMeteo={this.handleFormData}
                                    />
                                </Grid>
                            </Fragment>
                        )}
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="rentAgency"
                                value={!homeForm.rentAgency || homeForm.rentAgency === null ? '' : homeForm.rentAgency}
                                error={textInput_error.rentAgency}
                                label={Translator.translate('general.table.column.rentAgency')}
                                name="rentAgency"
                                onChange={this.handleChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="altitude"
                                type="number"
                                inputProps={{ pattern: 'd+' }}
                                value={!homeForm.altitude || homeForm.altitude === null ? '' : homeForm.altitude}
                                error={textInput_error.altitude}
                                label={Translator.translate('general.table.column.altitude')}
                                name="altitude"
                                onChange={this.handleChange}
                                suffix="m"
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="latitude"
                                type="number"
                                value={!homeForm.latitude || homeForm.latitude === null ? '' : homeForm.latitude}
                                error={textInput_error.latitude}
                                label={Translator.translate('general.table.column.latitude')}
                                name="latitude"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="longitude"
                                type="number"
                                value={!homeForm.longitude || homeForm.longitude === null ? '' : homeForm.longitude}
                                error={textInput_error.longitude}
                                label={Translator.translate('general.table.column.longitude')}
                                name="longitude"
                                onChange={this.handleChange}
                            />
                        </Grid>
                    </Grid>
                </FHEContainerForm>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    const homeId = match.params.homeId;
    const selectors = getSelectors(history.environment);
    return {
        homeId,
        profile: selectors.getProfile(state),
        home: selectors.getHomeByHomeId(state, homeId),
        searchCityUrl: selectors.getSearchCityUrl(state),
        managements: selectors.getManagements(state),
        managementsArray: selectors.getManagementsArray(state)
    };
}

const styles = theme => ({
    activedColor: {
        color: theme.palette.success.main
    },
    disactivedColor: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    renderEnvComponent('scenes/Home/forms/FormHome', connect(mapStateToProps)(withStyles(styles, { withTheme: true })(FormHome)))
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/forms/FormHome.js